import React from 'react';

import {
  Status,
  CheckCircleIcon,
  NotInterestedIcon,
  Typography,
  Stack,
} from '@gogame/components';

import { ACTIVE, ARCHIVED, ERROR, UPDATING, PENDING } from './constants';

export const getColor = (id) => {
  switch (id) {
    case ACTIVE:
      return 'success';
    case ARCHIVED:
      return 'inactive';
    case ERROR:
      return 'error';
    case UPDATING:
      return 'info';
    case PENDING:
      return 'pending';
  }
};

export const ASStatus = ({ isOn }) => {
  const color = isOn ? 'success' : 'inactive';
  return (
    <Stack direction={'row'} spacing={1} alignItems={'center'}>
      {isOn ? (
        <CheckCircleIcon key={color} sx={{ fontSize: 16 }} color={color} />
      ) : (
        <NotInterestedIcon key={color} sx={{ fontSize: 16 }} color={color} />
      )}
      <Typography> {isOn ? 'On' : 'Off'}</Typography>
    </Stack>
  );
};

const AudienceStatus = ({ id, children }) => {
  return <Status color={getColor(id)}>{children}</Status>;
};

export default AudienceStatus;
